import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Scadenza } from '../../../models/scadenza';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';
import { ScadenzaAddConcreteFormComponent } from './scadenza-add-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_aggiungi_scadenza]',
  templateUrl: 'scadenza-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})
export class ScadenzaModAddComponent {

    @Output()
    onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();

    @Output()
    onScadenzaInseritaForAuto: EventEmitter<Scadenza> = new EventEmitter<Scadenza>();

    @Output()
    lastID: EventEmitter<string> = new EventEmitter<string>();


  @ViewChild('formScadenzario') formScadenzario: ScadenzaAddConcreteFormComponent;

  inizializza(urlAddScadenza: string, idSezione: string, idFascicolo: string, fascicoloGeneric: string) {
    openModal('modaladdscad');
    this.formScadenzario.inizializza(urlAddScadenza, idSezione, idFascicolo, fascicoloGeneric);
  }

  createForm() {
    this.formScadenzario.createForm();
  }

  manageModal(sezione: SezioneScadenze) {
    if (sezione) {
      closeModal('modaladdscad');
      this.onReturn.emit(sezione);
    }
  }

  getLastID(lastID){
    console.log(lastID)
    this.lastID.emit(lastID)

  }

  eventoScadenzaInseritaForAuto(scadenzaIns: Scadenza){
    this.onScadenzaInseritaForAuto.emit(scadenzaIns);
  }
}
